import { render, staticRenderFns } from "./TextInCenter.vue?vue&type=template&id=500b4ab3&scoped=true&lang=html&"
import script from "./TextInCenter.vue?vue&type=script&lang=js&"
export * from "./TextInCenter.vue?vue&type=script&lang=js&"
import style0 from "./TextInCenter.vue?vue&type=style&index=0&id=500b4ab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b4ab3",
  null
  
)

export default component.exports